module.exports = __webpack_public_path__ + "img/status2.fba59936.png";